module.exports = __webpack_public_path__ + "dda2ef7542f553fef0285892664425bb.png";